"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)("path", {
    d: "M237.5 275.4v62.5h-50c-6.9 0-12.5 5.6-12.5 12.5s5.6 12.5 12.5 12.5h125c6.9 0 12.5-5.6 12.5-12.5s-5.6-12.5-12.5-12.5h-50v-62.5h-25z"
  }), (0, _core.jsx)("path", {
    d: "M175 137.9v100c0 41.4 33.6 75 75 75s75-33.6 75-75v-100H175z"
  }), (0, _core.jsx)("path", {
    d: "M350 162.9v37.5c0 20.7-16.8 37.5-37.5 37.5h-125c-20.7-.1-37.4-16.8-37.5-37.5v-37.5h200m0-25H150c-13.8 0-25 11.2-25 25v37.5c0 34.5 28 62.5 62.5 62.5h125c34.5 0 62.5-28 62.5-62.5v-37.5c0-13.8-11.2-25-25-25zM97.9 269.1v31.2h-25c-3.5 0-6.3 2.8-6.3 6.2s2.8 6.2 6.3 6.2h62.5c3.5 0 6.2-2.8 6.2-6.2s-2.8-6.2-6.2-6.2h-25v-31.2H97.9z"
  }), (0, _core.jsx)("path", {
    d: "M135.6 270.6c-5.6 9-14.8 15-25.2 16.7H97.9c-13.5-2.1-24.7-11.5-29.2-24.4-1.4-3.9-2.1-8-2.1-12.1v-50.4h37.5v10.4c-.1.7-.1 1.4 0 2.1.2 13.4 4.2 26.4 11.7 37.5 5.1 8.2 11.7 15.3 19.6 20.8l.2-.6z"
  }), (0, _core.jsx)("path", {
    d: "M116 250.4H72.9c-2.1 0-4.3-.4-6.2-1.2-7.5-2.6-12.5-9.6-12.5-17.5V213h50c-.1-.7-.1-1.4 0-2.1v-10.4h-50c-6.9 0-12.5 5.6-12.5 12.5v18.8c-.4 15.7 11.3 29.2 27.1 31.1 1.4.2 2.8.2 4.2 0h53.3c-4-3.7-7.4-7.9-10.3-12.5zM389.6 269.1v31.2h-25c-3.5 0-6.2 2.8-6.2 6.2s2.8 6.2 6.2 6.2h62.5c3.5 0 6.2-2.8 6.2-6.2s-2.8-6.2-6.2-6.2h-25v-31.2h-12.5z"
  }), (0, _core.jsx)("path", {
    d: "M433.3 200.4v50c.1 4.1-.7 8.2-2.1 12.1-4.4 13-15.6 22.6-29.2 24.8h-12.4c-10.4-1.6-19.6-7.7-25.2-16.7 7.9-5.6 14.5-12.6 19.6-20.8 7.4-10.9 11.5-23.7 11.9-36.9.1-.7.1-1.4 0-2.1v-10.4h37.4z"
  }), (0, _core.jsx)("path", {
    d: "M445.8 200.4h-50v10.4c.1.7.1 1.4 0 2.1h50v18.8c0 7.9-5 14.9-12.5 17.5-2 .9-4.1 1.3-6.2 1.2H384c-2.9 4.6-6.3 8.8-10.2 12.5h53.3c1.4.2 2.8.2 4.2 0 15.7-1.9 27.4-15.4 27.1-31.2v-18.8c-.1-6.9-5.7-12.5-12.6-12.5z"
  }));
};

exports.default = _default;